import { GetServerSideProps } from 'next';

import { wrapper } from 'src/redux/store/store';
import { MainContainer } from 'src/components/dynamic';
import { getHomepageHandler } from 'lib/page.service';

export const getServerSideProps: GetServerSideProps = wrapper
// @ts-ignore
  .getServerSideProps(getHomepageHandler('matchnow-homepage'));

export default MainContainer;
